<template>
  <section id="fitness" class="fitness-section">
    <div class="fitness">
      <div class="slick-carousel">
        <div>
          <img src="/img/fitness/fitness1.jpg" alt="">
        </div>
        <div>
          <img src="/img/fitness/fitness2.jpg" alt="">
        </div>
        <div>
          <img src="/img/fitness/fitness3.jpg" alt="">
        </div>
      </div>
      <div class="m-slider">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img data-src="img/fitness/fitness1.jpg" class="swiper-lazy" alt="">
              <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
            </div>
            <div class="swiper-slide">
              <img data-src="img/fitness/fitness2.jpg" class="swiper-lazy" alt="">
              <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
            </div>
            <div class="swiper-slide">
              <img data-src="img/fitness/fitness3.jpg" class="swiper-lazy" alt="">
              <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
            </div>

          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination swiper-pagination-white"></div>
        </div>
      </div>
      <div class="content">
        <h2 class="title">
          {{$t('fitnessSection.title')}}
        </h2>
        <p class="text">
          {{$t('fitnessSection.text')}}
        </p>
      </div>
    </div>
<!--    <div class="casino">-->
<!--      <div class="slick-carousel">-->
<!--        <div>-->
<!--          <img src="/img/casino/7.jpg" alt="">-->
<!--        </div>-->
<!--        <div>-->
<!--          <img src="/img/casino/8.jpg" alt="">-->
<!--        </div>-->
<!--        <div>-->
<!--          <img src="/img/casino/9.jpg" alt="">-->
<!--        </div>-->
<!--        <div>-->
<!--          <img src="/img/casino/14.jpg" alt="">-->
<!--        </div>-->
<!--        <div>-->
<!--          <img src="/img/casino/15.jpg" alt="">-->
<!--        </div>-->
<!--        <div>-->
<!--          <img src="/img/casino/16.jpg" alt="">-->
<!--        </div>-->
<!--        <div>-->
<!--          <img src="/img/casino/17.jpg" alt="">-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="m-slider">-->
<!--        <div class="swiper-container">-->
<!--          <div class="swiper-wrapper">-->
<!--            <div class="swiper-slide">-->
<!--              <img data-src="img/casino/7.jpg" class="swiper-lazy" alt="">-->
<!--              <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>-->
<!--            </div>-->
<!--            <div class="swiper-slide">-->
<!--              <img data-src="img/casino/8.jpg" class="swiper-lazy" alt="">-->
<!--              <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>-->
<!--            </div>-->
<!--            <div class="swiper-slide">-->
<!--              <img data-src="img/casino/9.jpg" class="swiper-lazy" alt="">-->
<!--              <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>-->
<!--            </div>-->
<!--            <div class="swiper-slide">-->
<!--              <img data-src="img/casino/14.jpg" class="swiper-lazy" alt="">-->
<!--              <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>-->
<!--            </div>-->
<!--            <div class="swiper-slide">-->
<!--              <img data-src="img/casino/15.jpg" class="swiper-lazy" alt="">-->
<!--              <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>-->
<!--            </div>-->
<!--            <div class="swiper-slide">-->
<!--              <img data-src="img/casino/16.jpg" class="swiper-lazy" alt="">-->
<!--              <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>-->
<!--            </div>-->
<!--            <div class="swiper-slide">-->
<!--              <img data-src="img/casino/17.jpg" class="swiper-lazy" alt="">-->
<!--              <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>-->
<!--            </div>-->

<!--          </div>-->
<!--          &lt;!&ndash; Add Pagination &ndash;&gt;-->
<!--          <div class="swiper-pagination swiper-pagination-white"></div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="content">-->
<!--        <h2 class="title">-->
<!--          {{$t('fitnessSection.casinoTitle')}}-->
<!--        </h2>-->
<!--        <p class="text">-->
<!--          {{$t('fitnessSection.casinoText')}}-->
<!--        </p>-->
<!--        <ul>-->
<!--          <li>{{$t('fitnessSection.casinoListItem1')}}</li>-->
<!--          <li>{{$t('fitnessSection.casinoListItem2')}}</li>-->
<!--          <li>{{$t('fitnessSection.casinoListItem3')}}</li>-->
<!--          <li>{{$t('fitnessSection.casinoListItem4')}}</li>-->
<!--          <li>{{$t('fitnessSection.casinoListItem5')}}</li>-->
<!--        </ul>-->
<!--        <p class="text">{{$t('fitnessSection.casinoText2')}}</p>-->
<!--      </div>-->
<!--    </div>-->
  </section>
</template>

<script>
export default {
  name:'Fitness'
}

</script>
